// src/components/TokenDetails.js
import React from 'react';

export default function TokenDetails({ tokenData }) {
  // Default values if tokenData is not provided
  const {
    name = "Prediction Arena",
    symbol = "ARENA",
    contractAddress = "HFqQ6xKTEyL2RSS7b8Ss5Sn4qgFqbL5b4rZmDhMhpkin",
    chain = "Solana",
    totalSupply = "1,000,000,000",
    solscanUrl = "https://solscan.io/token/HFqQ6xKTEyL2RSS7b8Ss5Sn4qgFqbL5b4rZmDhMhpkin",
    chartUrl = "https://dexscreener.com/solana/HFqQ6xKTEyL2RSS7b8Ss5Sn4qgFqbL5b4rZmDhMhpkin",
    isLaunched = true,
    launchDate = "May 6, 2025",
  } = tokenData || {};

  // Function to truncate contract address for display
  const truncateAddress = (address) => {
    if (!address) return "";
    if (address.length <= 15) return address;
    return `${address.substring(0, 8)}...${address.substring(address.length - 6)}`;
  };

  // Function to copy text to clipboard
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        // You could add a toast notification here in a real app
        console.log('Copied to clipboard');
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
      });
  };

  return (
    <section id="token-details" className="my-8 font-mono">
      {/* Section title */}
      <div className="flex items-center mb-4">
        <h3 className="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-violet-400 to-pink-400">
          Token Details
        </h3>
        <div className="flex-grow h-px ml-4 bg-gradient-to-r from-violet-500/50 via-pink-500/50 to-transparent"></div>
        <div className="ml-2 px-2 py-1 bg-black bg-opacity-40 rounded text-xs text-pink-400 border border-pink-500/30">
          {isLaunched ? "Live" : `Launch: ${launchDate}`}
        </div>
      </div>

      {/* Gradient border wrapper */}
      <div className="animate-gradient-border mb-12 pt-4 mt-8 p-0.5 rounded-3xl mx-auto max-w-2xl">
        {/* Inner dark card */}
        <div className="bg-gray-900 rounded-3xl p-6 sm:p-8 lg:p-10 shadow-lg">
          <div className="flex justify-between items-center mb-6">
            <div>
              <h2 className="text-xl font-bold text-white">{name} <span className="text-gray-400">({symbol})</span></h2>
              <p className="text-gray-400 text-sm mt-1">on {chain}</p>
            </div>
            <div className="flex space-x-2">
              <a 
                href={solscanUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className="px-3 py-1.5 bg-indigo-900/50 hover:bg-indigo-800/60 rounded-lg text-xs text-indigo-300 border border-indigo-700/30 transition"
              >
                Solscan
              </a>
              <a 
                href={chartUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className="px-3 py-1.5 bg-pink-900/50 hover:bg-pink-800/60 rounded-lg text-xs text-pink-300 border border-pink-700/30 transition"
              >
                Chart
              </a>
            </div>
          </div>

          {/* Token details grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            <div className="bg-gray-800/50 rounded-xl p-4">
              <p className="text-gray-400 text-xs mb-1">Contract Address</p>
              <div className="flex items-center">
                <p className="text-gray-200 text-sm font-medium">{truncateAddress(contractAddress)}</p>
                <button 
                  onClick={() => copyToClipboard(contractAddress)}
                  className="ml-2 p-1.5 rounded-md bg-gray-700/70 hover:bg-gray-700 transition"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                  </svg>
                </button>
              </div>
            </div>
            
            <div className="bg-gray-800/50 rounded-xl p-4">
              <p className="text-gray-400 text-xs mb-1">Total Supply</p>
              <p className="text-gray-200 text-sm font-medium">{totalSupply}</p>
            </div>
            
            <div className="bg-gray-800/50 rounded-xl p-4">
              <p className="text-gray-400 text-xs mb-1">Chain</p>
              <p className="text-gray-200 text-sm font-medium">{chain}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
